<template>
  <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
    <v-app-bar
      v-if="selectedTabData.loadingProgress == 100"
      outlined
      flat
      color="white"
      height="52px"
      style="border-bottom: 1px solid #ededed !important; z-index: 99"
    >
      <IconTooltipButtonBottom
        icon="mdi-arrow-left"
        tooltip="Zurück zur Liste"
        id="default"
        width="50px"
        large
        @click="$router.go(-1)"
      />
      <v-spacer></v-spacer>
      <div>
        <v-chip
          small
          v-if="selectedTabData.pxMode"
          label
          color="lightgreen_s"
          text-color="lightgreen"
          class="text-uppercase text-black font-xs mr-2"
          style="padding: 4px 6px"
        >
          <v-icon small class="mr-1">mdi-emoticon-happy-outline</v-icon>
          <span style="font-size: 10px">PX Modus</span>
        </v-chip>
        <span v-if="selectedTabData.editingMode">
          <v-icon color="primary" style="transform: rotate(-90deg)" class="mr-2"
            >mdi-sitemap</v-icon
          >
        </span>
        <span class="mr-2 h4">{{ selectedTabData.fileName }}</span>
        <span>
          <span
            class="text-tag"
            >.bpmn</span
          >
        </span>
      </div>
      <v-spacer
        :style="'flex-grow: ' + setSpacerMargin() + ' !important;'"
      ></v-spacer>
      <!--      Edit & Viewer Mode-->
      <div id="modelingButtons" class="mr-4">
        <div>
          <v-btn id="publishBtn" density="compact" color="error" elevation="0" @click="changeRequestState('REJECTED', false)" :disabled="!currentUserIsReviewer"><v-icon>mdi-close</v-icon>Ablehnen</v-btn>
      <v-menu offset-y max-width="400">
      <template v-slot:activator="{ on, attrs }">
        <v-btn id="publishBtn" density="compact" color="success" elevation="0" v-bind="attrs"
          v-on="on" :disabled="!currentUserIsReviewer">Freigeben <v-icon>mdi-chevron-down</v-icon></v-btn>
      </template>
      
      <v-list>
        <v-hover v-slot="{ hover }">
        <v-list-item two-line @click="changeRequestState('ACCEPTED', false)" :style="{ 'background-color': hover ? 'var(--v-primary-lighten2)' : '' }">
          <v-list-item-content>
            <v-list-item-title>Freigeben</v-list-item-title>
            <v-list-item-subtitle>Die hier angezeigte Version wird freigegeben</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        </v-hover>
        <hr style="margin:0px; border-top: 1px solid var(--v-secondary-base)"/>
        <v-hover v-slot="{ hover }">
          <v-list-item two-line @click="changeRequestState('ACCEPTED', true)" :style="{ 'background-color': hover ? 'var(--v-primary-lighten2)' : '' }">
            <v-list-item-content>
              <v-list-item-title>Freigeben & Bearbeiten</v-list-item-title>
              <v-list-item-subtitle>Sie können den Prozess nach der Freigabe direkt bearbeiten ohne eine neue Freigabeanfrage stellen zu müssen</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-hover>
        </v-list>
      </v-menu>      
        </div>
      </div>
    </v-app-bar>
    <div
      v-if="selectedTabData.loadingProgress == 100"
      id="left"
      style="margin-left:250px"
      :class="[showSidePanel ? 'commentsOpened' : 'commentsClosed']"
    >
      <BpmnViewer
        ref="bpmnViewer"
        :diagramXML="diagramXML"
        :elementsToLabel="selectedTabData.elementsToLabel"
        :evalMode="selectedTabData.showEvaluation"
        v-if="selectedTabData && !selectedTabData.editingMode && currentUserIsReviewer"
        class="fill-height"
        @elementClicked="onElementClicked"
        @createBadge="setBadgesForMode"
        @createEvaluationBadge="setEvaluationBadge"
        @hideEvaluationBadges="hideEvaluationBadge"
      />
      <ConfirmDialog ref="confirmDialog" />
      <InfoDialog ref="infoDialog" />
    </div>
    <div id="right" v-if="showSidePanel" style="margin-top: 1px">
      <ProcessModelingSidePanel :selectedTabData="selectedTabData" :canEdit="true" @processChanged="processChanged" @saveFile="saveFile"/>
    </div>
    <div id="leftHistory" style="margin-top: 1px">
      <v-card style="height: 100%">
        <div
          style="position: absolute; top: 0; right: 0; left: 0; height: 40px; text-align-last: center;"
          class="border-bottom"
        >
          <h4>Änderungsverlauf</h4>
        </div>
        <div style="position: absolute; top: 40px; right: 0; left: 0; height:calc(100% - 40px)">
          <ProcessReviewRequestSection :review-requests="selectedTabData.contextInfo.reviewRequests"/>
        </div>
      </v-card>
    </div>
    <div
      :class="
        showSidePanel ? 'sidePanelExpand pointer' : 'sidePanelCollapsed pointer'
      "
      @click="showSidePanel = !showSidePanel"
    >
      <div v-if="!showSidePanel">
        <v-icon color="secondary" large>mdi-chevron-left</v-icon>
      </div>
      <div v-if="showSidePanel">
        <v-icon color="secondary" large>mdi-chevron-right</v-icon>
      </div>
    </div>
    <v-progress-linear
      :style="
        'position: absolute; bottom: 0; display:' +
        (selectedTabData.loadingProgress == 100
          ? 'none;'
          : 'block; z-index:99;')
      "
      color="gray accent-4"
      :indeterminate="selectedTabData.loadingProgress == 100 ? false : true"
      height="4"
      :value="selectedTabData.loadingProgress"
    ></v-progress-linear>
    <v-snackbar
      location="center"
      rounded="pill"
      v-model="snackbar.value"
      outlined
      timeout="-1"
      :color="snackbar.status"
      class="mb-12"
    >
      <span class="middle-aligned">
        <v-progress-circular
          v-if="snackbar.loading"
          indeterminate
          :color="snackbar.status"
        ></v-progress-circular>
        <v-icon v-if="snackbar.icon" :color="snackbar.status">{{
          snackbar.icon
        }}</v-icon>
        {{ snackbar.msg }}
      </span>
    </v-snackbar>

  </div>
</template>

<script>
import ProcessShareDialog from "@/pages/ProcessModeling/ProcessShareDialog";
import UserListDialog from "@/pages/ProcessModeling/UserListDialog";
import ConfirmDialog from "@/components/common/ConfirmDialog";
import InfoDialog from "@/components/common/InfoDialog";

import processModelingService from "@/pages/ProcessModeling/process-modeling-service";

import IconTooltipButton from "@/components/common/IconTooltipButton";
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom";

import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
import BpmnEditor from "@/pages/ProcessModeling/BpmnEditor";
import CommentsSection from "@/pages/ProcessModeling/Menu/CommentsSection/CommentsSection";
import HistorySection from "@/pages/ProcessModeling/Menu/HistorySection/HistorySection";

import QuestionSection from "@/pages/ProcessModeling/Menu/QuestionSection/QuestionSection";
import DocumentSection from "@/pages/ProcessModeling/Menu/DocumentSection/DocumentSection.vue";
import PxQuestionSection from "@/pages/ProcessModeling/Menu/PxQuestionSection/PxQuestionSection.vue";

import VueTabsChrome from "vue-tabs-chrome";
import { hexToRgb, getContrastColor } from "@/components/colorContrast.js";
import PreviewProcessModelDialog from "@/components/PreviewProcessModelDialog.vue";

import ShowQuestionsPreview from "@/pages/ProcessModeling/Menu/PxMode/ShowQuestionsPreview.vue";

import PxModeEvaluationPanel from "@/pages/ProcessModeling/Menu/PxMode/PxModeEvaluationPanel.vue";
import PxElementQuestionEvaluationPanel from "@/pages/ProcessModeling/Menu/PxMode/PxElementQuestionEvaluationPanel.vue";

import { getBusinessObject } from "prime-custom-modeling/lib/util/ModelUtil";
import ElementDescriptionSection from "@/pages/ProcessModeling/Menu/ElementDescriptionSection/ElementDescriptionSection.vue";
import PublishDialog from '@/pages/ProcessModeling/Review/PublishDialog.vue';
import ProcessReviewRequestSection from "./ReleaseSection/ProcessReviewRequestSection.vue";
import processPublishService from "@/components/processPublishService.js";

import ProcessModelingSidePanel from '@/pages/ProcessModeling/ProcessModelingSidePanel.vue';
export default {
  components: {
    ProcessShareDialog,
    UserListDialog,
    IconTooltipButton,
    IconTooltipButtonBottom,
    ConfirmDialog,
    InfoDialog,
    BpmnViewer,
    BpmnEditor,
    CommentsSection,
    HistorySection,
    DocumentSection,
    QuestionSection,
    PxQuestionSection,
    VueTabsChrome,
    PreviewProcessModelDialog,
    ShowQuestionsPreview,
    PxModeEvaluationPanel,
    PxElementQuestionEvaluationPanel,
    ElementDescriptionSection,
    PublishDialog,
    ProcessReviewRequestSection,
    ProcessModelingSidePanel
},
  props: {},
  data: function () {
    return {
      showProcessSharedialog: false,
      showUserListDialog: false,
      fileName: String,
      showSidePanel: false,
      showQuestionPanel: false,
      badgeColor: "#" + this.$store.state.clientColor,
      canEdit: false,
      currentUserIsReviewer: false,
      tabs: [],
      tab: "",
      selectedTabData: [],
      evaluations: [],
      snackbar: {
        value: false,
        status: "secondary",
        msg: "",
        loading: false,
        icon: null,
      },
    };
  },
  updated() {
    let rgbPrimary = hexToRgb(this.$vuetify.theme.themes.light.primary);
    let foregroundColor = getContrastColor(rgbPrimary);

    if (document.getElementById("editTooltip") != null)
      document.getElementById("editTooltip").style.color = foregroundColor;
  },
  async mounted() {
    this.$store
      .dispatch("checkFolderPermission", {
        processId: this.uuid,
        permission: "PROCESS_WRITE",
      })
      .then((res) => {
        this.canEdit = res;
      });
    if (this.uuid) {

        processModelingService
          .retrieveModelInformation(this.uuid)
          .then(async (result) => {
            let contextInfo = result.data;
            let reviewId = contextInfo.reviewRequests.sort((a,b) => b.createdDate - a.createdDate)[0].id;
            this.currentUserIsReviewer = contextInfo.reviewRequests.length && this.userId === contextInfo.reviewRequests[0].reviewer
            processModelingService.getReviewProcessXml(this.uuid, reviewId).then(async (res) => {
            const elementsWithAttachments =
            await processModelingService.getElementsWithAttachments(this.uuid);
            var elementsToLabel = elementsWithAttachments.data;
            let diagramXML = res.data;
            let fileName = result.data.fileName;
            let editingMode = false;
            if (
              result.data.currentEditor &&
              result.data.currentEditor === this.userId
            ) {
              editingMode = true;
            } else {
              editingMode = false;
            }
            await this.initTabs(
              fileName,
              diagramXML,
              elementsToLabel,
              editingMode,
              contextInfo
            );
            this.fetchDiagram();
            this.fileName = fileName;
          });
      });
    }
  },
  watch: {
    uuid: function (val) {
      this.$emit("loading");
      //if (val) this.fetchDiagram();
    },
    tab(val) {
      this.selectedTabData = this.tabs.find((item) => item.key === val);
    },
  },
  computed: {
    userId() {
      return this.$store.getters.user.username;
    },
    uuid() {
      return this.$route.params.uuid;
    },
    isNew() {
      return this.$route.params.isNew == null
        ? false
        : this.$route.params.isNew;
    },
    diagramXML() {
      if (this.selectedTabData.pxMode && this.selectedTabData.showEvaluation) {
        return this.selectedTabData.surveyModel;
      } else {
        return this.selectedTabData.diagramXML;
      }
    },
    modelDiffrent() {
      if (this.selectedTabData.surveyModel == null) return false;
      return (
        this.selectedTabData.surveyModel != this.selectedTabData.diagramXML
      );
    },
  },
  methods: {
    closeHistory() {
      this.tooling = "";
    },
    async initTabs(
      fileName,
      diagramXML,
      elementsToLabel,
      editingMode,
      contextInfo
    ) {
      let pxWrite = await this.$store.dispatch("checkFolderPermission", {
        processId: this.uuid,
        permission: "PX_WRITE",
      });
      let pxEval = await this.$store.dispatch("checkFolderPermission", {
        processId: this.uuid,
        permission: "PX_EVAL",
      });
      let modelInformation = await processModelingService.retrieveModelInformation(this.uuid);
      let newTabs = [
        {
          label: fileName,
          key: this.uuid,
          uuid: this.uuid,
          closable: false,
          diagramXML: diagramXML,
          elementsTolabel: elementsToLabel,
          editingMode: editingMode,
          fileName: fileName,
          contextInfo: contextInfo,
          selectedElement: null,
          showEvaluation: false,
          pxMode: false,
          loadingProgress: 0,
          preselectedSurvey: null,
          pxWrite: pxWrite,
          pxEval: pxEval,
          modelInformation: modelInformation.data
        },
      ];
      this.tabs.push(...newTabs);
      this.tab = this.uuid;
      this.selectedTabData = newTabs[0];
    },
    onElementClicked(value) {
      this.selectedTabData.selectedElement = value;
      if (this.selectedTabData.selectedElement)
        this.loadColoredElements(this.selectedTabData.selectedElement.id);
    },
    setBadgesForMode(overlays, elementRegistry) {
      let self = this;
      let elements = elementRegistry.getAll();
      elements.forEach((elem) => overlays.remove({ element: elem.id }));
      if (
        this.selectedTabData.elementsToLabel == null ||
        this.selectedTabData.elementsToLabel.length < 1
      )
        return;

      if (this.selectedTabData.pxMode) {
        let type = "px";
        for (const element of this.selectedTabData.elementsToLabel.filter(
          (elem) => elem.hasQuestion
        )) {
          const badge = processModelingService.createPxBadge(element);
          if (elementRegistry.get(element.elementId)) {
            badge.html.click(function (e) {
              self.badgeClicked(elementRegistry.get(element.elementId), type);
            });
            let overlayId = overlays.add(element.elementId, badge);
            element.overlay = {
              type: type,
              id: overlayId,
            };
          }
        }
      } else {
        let type = "context";
        for (const element of this.selectedTabData.elementsToLabel.filter(
          (elem) => elem.hasComment || elem.hasDocument || elem.hasDescription
        )) {
          const badge = processModelingService.createContextBadge(element);
          if (elementRegistry.get(element.elementId)) {
            badge.html.click(function (e) {
              let target = "comments";
              switch (e.target.innerHTML) {
                case "forum":
                  target = "comments";
                  break;
                case "description":
                  target = "documents";
                  break;
                case "edit":
                  target = "description";
                  break;
              }
              self.badgeClicked(
                elementRegistry.get(element.elementId),
                type,
                target
              );
            });
            let overlayId = overlays.add(element.elementId, badge);
            element.overlay = {
              type: type,
              id: overlayId,
            };
          }
        }
      }
    },
    badgeClicked(element, type, target) {
      this.onElementClicked(element);
      if (type == "eval") {
        let elementEvals = this.selectedTabData.evalData.filter(
          (elem) => elem.elementId == element.id
        );
        let bo = getBusinessObject(element);
        let elem = {
          id: element.id,
          name: bo.name,
        };
        this.$refs.elementQuestionEvaluation.open(
          elementEvals[0],
          elem,
          this.selectedTabData.currentSurvey
        );
        this.showSidePanel = false;
      } else {
        this.showSidePanel = true;
        this.sidemenuTab = target;
      }
    },
    async saveFile(reload = false) {
      this.snackbar = {
        value: true,
        status: "secondary",
        msg: "Speichern läuft...",
        loading: true,
        icon: null,
      };
      if (this.selectedTabData.editingMode) {
          this.$refs.bpmnEditor
            .saveFile()
            .then((xml) => {
              processModelingService
                .uploadFileAsText(this.selectedTabData.uuid, xml)
                .then(() => {
                  this.snackbar = {
                    value: true,
                    status: "success",
                    msg: "Speichern erfolgreich",
                    loading: false,
                    icon: "mdi-check-bold",
                  };
                  setTimeout(() => {
                    this.snackbar = {
                      value: false,
                      status: "success",
                      msg: "",
                      loading: false,
                      icon: "",
                    };
                    if (this.$refs.history != null)
                      this.$refs.history.retrieveHistory();
                    if (reload) window.location.reload();
                  }, 2000);
                });
            })
            .catch((error) => {
              this.snackbar = {
                value: true,
                status: "error",
                msg: "Speichern fehlgeschlagen",
                loading: false,
                icon: "mdi-close",
              };
              setTimeout(() => {
                this.snackbar = {
                  value: false,
                  status: "success",
                  msg: "",
                  loading: false,
                  icon: "",
                };
                console.log(error);
              }, 2000);
            });
        }
    },
    exportXML() {
      var result;
      if (this.selectedTabData.editingMode) {
        result = this.$refs.bpmnEditor.exportXML();
      } else {
        result = this.$refs.bpmnViewer.exportXML();
      }
      if (result != null)
        result
          .then((xml) => {
            this.downloadFile(xml);
          })
          .catch((e) => console.log(e));
    },
    exportPDF() {
      let result;
      if (this.selectedTabData.editingMode) {
        result = this.$refs.bpmnEditor.exportPDF();
      } else {
        result = this.$refs.bpmnViewer.exportPDF();
      }
      if (result != null)
        result
          .then((svg) => {
            this.createPDFandDownload(svg);
          })
          .catch((e) => console.log(e));
    },
    createPDFandDownload(svg) {
      const docDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        content: [
          "Prozessmodell für " + this.selectedTabData.fileName,
          {
            svg: svg,
            width: 800,
            height: 500,
            style: "centering",
          },
        ],
        styles: {
          centering: {
            alignment: "center",
          },
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download(this.selectedTabData.fileName + ".pdf");
    },
    downloadFile(xml) {
      const file = new Blob([xml], { type: "application/xml" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = this.selectedTabData.fileName + ".bpmn";
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async processChanged(needsRefresh = false) {
      this.tooling = "";
      const elementsWithAttachments =
        await processModelingService.getElementsWithAttachments(
          this.selectedTabData.uuid
        );
      var elementsToLabel = elementsWithAttachments.data;

      this.selectedTabData.elementsToLabel = elementsToLabel;
      if (this.selectedTabData.editingMode) {
        this.$refs.bpmnEditor.setBadges();
      } else {
        this.$refs.bpmnViewer.setBadges();
      }
      if (needsRefresh) this.fetchDiagram();
    },

    switchModel(uuid) {
      this.$router.push("/modelEdit/" + uuid);
    },
    fetchDiagram() {
      this.selectedTabData.loadingProgress = 0;
      let reviewId = this.selectedTabData.contextInfo.reviewRequests.sort((a,b) => b.createdDate - a.createdDate)[0].id;
      processModelingService
        .getReviewProcessXml(this.selectedTabData.uuid, reviewId)
        .then(async (result) => {
          var diagramXML = result.data;

          const elementsWithAttachments =
            await processModelingService.getElementsWithAttachments(
              this.selectedTabData.uuid
            );
          var elementsToLabel = elementsWithAttachments.data;

          this.selectedTabData.diagramXML = diagramXML;
          this.selectedTabData.elementsToLabel = elementsToLabel;
          if (this.$route.params.isNew) this.editModel();
          let isPxMode =
            this.$route.query.mode != null && this.$route.query.mode == "px";

          if (isPxMode) {
            this.selectedTabData.pxMode = true;
            this.selectedTabData.showEvaluation = true;
            this.selectedTabData.preselectedSurvey = this.$route.query.surveyId;
          }
          this.selectedTabData.loadingProgress = 100;
        });
    },
    loadColoredElements(elementId) {
      if (this.selectedTabData && this.selectedTabData.editingMode) {
        this.$refs.bpmnEditor.resetColorsInModel();
        this.$refs.bpmnEditor.colorElementInModel(
          elementId,
          this.$vuetify.theme.themes.light.primary,
          ""
        );
      } else {
        this.$refs.bpmnViewer.resetColorsInModel();
        this.$refs.bpmnViewer.colorElementInModel(
          elementId,
          this.$vuetify.theme.themes.light.primary,
          ""
        );
      }
    },
    setSpacerMargin() {
      if (this.selectedTabData.pxMode) {
        return "1";
      } else {
        if (!this.selectedTabData.editingMode && this.canEdit) {
          return "0.7";
        } else if (this.selectedTabData && this.selectedTabData.editingMode) {
          return "0.5";
        }
      }
    },
    publishFile(item){
      if (this.selectedTabData.editingMode) {
          this.$refs.bpmnEditor
            .saveFile()
            .then((xml) => {
              item.diagramXML = xml;
              this.$refs.publishDialog.open(
                item
              );
            })
            .catch((error) => {
                console.log(error);
              }, 2000);
        }

    },
    changeRequestState(requestState, editAfterPublish){
      this.selectedTabData.contextInfo.reviewRequests[0].requestState = requestState;
      processPublishService.changeRequestState(this.selectedTabData.contextInfo.reviewRequests[0]).then(res => {
        if(editAfterPublish){
          localStorage.setItem('editAfterPublish', true);
        }
        this.$router.push('/modelEdit/'+this.uuid);
      })
    }
  },
};
</script>
<style lang="less">
/*.tabs-item.active:after{*/
/*content : "";*/
/*  position: absolute;*/
/*  left    : 5%;*/
/*  bottom  : 0;*/
/*  height  : 1px;*/
/*  width   : 90%;  !* or 100px *!*/
/*  border-bottom:2px solid var(--v-primary-base);*/
/*}*/
#tabs {
  padding-top: 0px !important;
}
#modelingTooltips {
  width: fit-content;
  height: fit-content;
  z-index: 1;
}
#editmode {
  z-index: 1;
}
#modelingBar {
  position: fixed;
  bottom: 46px;
  margin-left: 25px;
  z-index: 1;
  padding: 12px;
  background-color: #fff;
  box-shadow: 0 0 20px #ededed;
  border: 1px solid #ededed;
  max-height: 50px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;

  :deep .v-label {
    margin-bottom: 0;
  }

  :deep .v-messages {
    display: none;
  }
}
#top,
#left,
#right {
  position: absolute;
}
#modelingButtons {
  background-color: white;
  display: inline;
}
#left,
#right {
  top: 52px;
  bottom: 0px;
}
#left > .v-card,
#right > .v-card {
  z-index: 99;
}
#left {
  left: 0;

}
.commentsOpened {
  right: 350px;
}
.commentsClosed {
  right: 0;
}
#right {
  width: 350px;
  right: 0;
}
.v-window,
.v-window__container,
.v-window-item {
  position: absolute !important;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.sidePanelCollapsed {
  height: 50px;
  position: fixed;
  background-color: #ebebeb;
  border-radius: 5px 2.5px 2.5px 5px;
  right: 0px;
  top: calc(50% - 55px);
  width: 36px;
  text-align: center;
  background: var(--gray-color_4);
  padding-top: 6px;
  /* -moz-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        -webkit-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        -o-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        -ms-transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg);
        transform: scale(1) rotate(270deg) translateX(0px) translateY(37.5px) skewX(0deg) skewY(0deg); */
}
.sidePanelExpand {
  height: 50px;
  position: fixed;
  background-color: #ebebeb;
  border-radius: 5px 2.5px 2.5px 5px;
  right: 350px;
  top: calc(50% - 55px);
  width: 36px;
  text-align: center;
  background: var(--gray-color_4);
  padding-top: 6px;

  /* -moz-transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg);
      -webkit-transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg);
      -o-transform: scale(1) rotate(270deg) translateX(0px) translateY(3-312.5px) skewX(0deg) skewY(0deg);
      -ms-transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg);
      transform: scale(1) rotate(270deg) translateX(0px) translateY(-312.5px) skewX(0deg) skewY(0deg); */
}
.verticalText {
  transform-origin: top left;
  left: 0;
  top: 50%;
  transform: rotate(-90deg) translateX(-100%);
}
#leftHistory{
    top: 52px;
    position: absolute;
    width: 250px;
    bottom: 0px;
    left: 0;
}
</style>
<style lang="less">
.vue-tabs-chrome.theme-custom {
  padding-top: 0;
  background-color: var(--gray-color_4) !important;
  font-size: 0.8rem;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 4;
  .tabs-footer,
  .tabs-divider,
  .tabs-background-before,
  .tabs-background-after {
    display: none;
  }
  .tabs-item {
    cursor: pointer;
  }
  .tabs-content {
    overflow: unset;
    border-top: 1px solid #e4e7ed;
  }
  .tabs-background {
    padding: 0;
  }
  .tabs-background-content {
    border-bottom: 1px solid #e4e7ed;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-radius: 0;
    background-color: #fff;
  }
  .tabs-content {
    height: 32px;
    width: 100vw;
  }
  .active {
    color: var(--gray-color);
    font-weight: 600;
    .tabs-background {
      position: relative;
      &::before,
      &::after {
        top: 100%;
        left: 0;
        content: "";
        width: 100%;
        height: 1px;
        background-color: #fff;
        z-index: 1;
        position: absolute;
      }
      /* &::before {
        top: 0;
        height: 2px;
        background-color: var(--v-primary-base);
      } */
    }
  }
}
#publishBtn{
  margin-left: 10px;
  margin-right: 10px;
}
a.v-tab {
  text-transform: none !important;
  letter-spacing: 0;
  font-weight: 600;
}
a.v-tab--active {
  font-weight: 700;
}
.evaluationText {
  position: absolute;
  opacity: 0.92;
  width: 50%;
  left: 27%;
  top: 100px;
  text-align: left;
  font-size: 0.8rem;
  padding: 1rem 2rem;
  background: #f5f5f5;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.text-tag {
  color: var(--v-primary-base);
  position: relative;
  font-weight: 700;
  font-size: 0.7rem;
  padding: 3px 0 0 6px;
  letter-spacing: 0.5px;
  &::after {
    content: "";
    width: 3rem;
    height: 21px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    background-color: var(--v-primary-base);
    opacity: 0.1;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
